import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import Cookies from 'js-cookie';
const initialState = {
    stocktransfer: [],
    warehouse: [],
    category: [],
    subCategory: [],
    product: [],
    store: [],
    success: false,
    message: '',
    loading: false,
    error: null,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getStocktransfer = createAsyncThunk(
    'stocktransfer/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllStocktransfer', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("response>>>>", response.data.products);
            return response;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getDetailsStocktransfer = createAsyncThunk(
    'stocktransfer/getDetailsStocktransfer',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getStocktransferById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(getStocktransfer());
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addStocktransfer = createAsyncThunk(
    'stocktransfer/add',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            // console.log("data", data);
            const response = await axiosInstance.post(BASE_URL + '/createStocktransfer', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("response@@@@@@@@@@@@", response.data);
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getStocktransfer());
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteStocktransfer = createAsyncThunk(
    'stocktransfer/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            // console.log("id@@@@@@@@@@@@", id);
            const response = await axiosInstance.delete(`${BASE_URL}/deleteStocktransfer/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getStocktransfer());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editStocktransfer = createAsyncThunk(
    'stocktransfer/edit',
    async (data, { dispatch, rejectWithValue }) => {
        const { id, ...rest } = data;
        try {
            // console.log("id>>>>>>>>>>", id);
            // console.log("rest>>>>>>>>>>", rest);
            const response = await axiosInstance.put(`${BASE_URL}/updateStocktransfer/${id}`, rest, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getStocktransfer());
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getstockWarehouseUser = createAsyncThunk(
    'getstockWarehouseUser/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstockWarehouseUser', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.warehouse;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstockcategory = createAsyncThunk(
    'getstockcategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstockCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstockSubCategory = createAsyncThunk(
    'getstockSubCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstockSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstockProducts = createAsyncThunk(
    'getstockProducts/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstockProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.product;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstockstore = createAsyncThunk(
    'getstockstore/get',
    async (_, { dispatch, rejectWithValue }) => {
        console.log("--------------------");
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstockstore', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log("response>>>>", response.data);
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const stocktransferSlice = createSlice({
    name: 'stocktransfer',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStocktransfer.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getStocktransfer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.stocktransfer = action.payload.data;
            })
            .addCase(getStocktransfer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })
            .addCase(getDetailsStocktransfer.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching detailed products...';
            })
            .addCase(getDetailsStocktransfer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Detailed stocktransfer fetched successfully';
                state.stocktransfer = Array.isArray(action.payload.data) ? action.payload.data : [];
            })
            .addCase(getDetailsStocktransfer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch detailed products';
            })
            .addCase(addStocktransfer.pending, (state) => {
                state.loading = true;
                state.message = 'Adding stocktransfer...';
            })
            .addCase(addStocktransfer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                // state.products.push(action.payload.data);
                // state.message = action.payload?.message || 'Product added successfully';
                if (Array.isArray(state.stocktransfer)) {
                    state.stocktransfer.push(action.payload.data);
                } else {
                    state.stocktransfer = [action.payload.data];
                }
                state.message = action.payload?.message || 'stocktransfer added successfully';
            })
            .addCase(addStocktransfer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add stocktransfer';
            })
            .addCase(deleteStocktransfer.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting stocktransfer...';
            })
            .addCase(deleteStocktransfer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                // state.products = state.products.filter((v) => v._id !== action.payload);
                // state.message = action.payload?.message || 'Product deleted successfully';
                if (Array.isArray(state.stocktransfer)) {
                    state.stocktransfer = state.stocktransfer.filter((st) => st._id !== action.payload);
                }
                state.message = action.payload?.message || 'stocktransfer deleted successfully';
            })
            .addCase(deleteStocktransfer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete stocktransfer';
            })
            .addCase(editStocktransfer.pending, (state) => {
                state.loading = true;
                state.message = 'Updating stock transfer...';
            })
            .addCase(editStocktransfer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.stocktransfer)) {
                    state.stocktransfer = state.stocktransfer.map((stocktransfer) =>
                        stocktransfer._id === action.payload._id ? action.payload : stocktransfer
                    );
                }
                state.message = action.payload?.message || 'stocktransfer updated successfully';
            })
            .addCase(editStocktransfer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update stocktransfer';
            })

            .addCase(getstockWarehouseUser.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getstockWarehouseUser.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.warehouse = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getstockWarehouseUser.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })

            .addCase(getstockcategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getstockcategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getstockcategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })

            .addCase(getstockSubCategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getstockSubCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getstockSubCategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })
            .addCase(getstockProducts.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getstockProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.product = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getstockProducts.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })

            .addCase(getstockstore.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching stocktransfer...';
            })
            .addCase(getstockstore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'stocktransfer fetched successfully';
                state.store = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getstockstore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch stocktransfer';
            })
    }
});

export default stocktransferSlice.reducer;